// src/components/Scorecard.jsx
import React, { useEffect, useState } from 'react';
import { supabase } from '../utils/supabaseClient';
import './Scorecard.css';

export default function Scorecard({ votingId }) {
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchVotes() {
      if (!votingId) return;

      // 1. Fetch the 'votes' JSON column from the CORRECT table: 'Votings'
      const { data, error } = await supabase
        .from('Votings') 
        .select('votes') // Fetch the JSON array directly
        .eq('id', votingId)
        .single();
      
      if (error) {
        console.error("Error fetching voting record:", error);
        setLoading(false);
        return;
      }

      // 2. Parse the JSON data
      // Your screenshot shows the column is named "votes" and contains a JSON array
      if (data && data.votes) {
        // If Supabase returns it as a string, parse it. If it's already an object, use it.
        const parsedVotes = typeof data.votes === 'string' 
          ? JSON.parse(data.votes) 
          : data.votes;
          
        setVotes(parsedVotes || []);
      }
      setLoading(false);
    }
    fetchVotes();
  }, [votingId]);

  if (loading) return <div className="sc-loading">Loading votes...</div>;
  if (!votes || votes.length === 0) return null;

  // Helper to style the vote pills
  const getVoteStyle = (voteString) => {
    const v = (voteString || '').toLowerCase();
    if (v.includes('yes') || v.includes('aye') || v.includes('favor')) return 'sc-pill yes';
    if (v.includes('no') || v.includes('nay') || v.includes('oppose')) return 'sc-pill no';
    return 'sc-pill abstain';
  };

  const getIcon = (voteString) => {
    const v = (voteString || '').toLowerCase();
    if (v.includes('yes') || v.includes('aye') || v.includes('favor')) return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
    );
    if (v.includes('no') || v.includes('nay') || v.includes('oppose')) return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    );
    return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>
    );
  };

  return (
    <div className="scorecard-container">
      <div className="sc-header">
        <span className="sc-label">Official Roll Call</span>
      </div>
      <div className="sc-grid">
        {votes.map((v, index) => (
          <div key={index} className={getVoteStyle(v.vote)}>
            <span className="sc-icon">{getIcon(v.vote)}</span>
            {/* Handle different JSON key names just in case */}
            <span className="sc-name">{v.name || v.boardMember || "Trustee"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}